// ─── Dashboards Layout Route ───
// /app/dashboards — the PARENT layout for the dashboards feature. Because
// `dashboards.$dashboardId.tsx` is a child route, this route is a layout and
// MUST render an <Outlet/> so the canvas child can mount; the exact-path
// index (resolve + redirect, §1.1) lives in `dashboards.index.tsx`. Rendering
// the index page directly here (with no Outlet) silently swallows every child
// route — the whole canvas becomes unreachable. See ADR 0021 (Phase 12 Batch 2).
//
// Phase 12 Batch 3 slice 3c: Dashboards now REPLACES /app/reports — the seeded
// "Project Status" + "Team Load" default dashboards plus the canvas toolbar
// (scope picker + date range + CSV/XLSX export) reproduce every report. The
// `/app/reports` route is kept only as a redirect alias here, and the sidebar's
// standalone "Reports" entry is gone.

import { createFileRoute, Outlet } from '@tanstack/react-router';

function DashboardsLayout(): React.ReactElement {
  return <Outlet />;
}

export const Route = createFileRoute('/app/dashboards')({
  component: DashboardsLayout,
});
